import { apiClient, Auth, HttpError } from '@/shared/api'

import { TContractRoomDetail } from '../model/schema'

type GetContractRoomParams = {
  roomId: number
  contractId: number
}

export const getContractRoom = async ({
  roomId,
  contractId,
}: GetContractRoomParams) => {
  try {
    const { data } = await apiClient.get<TContractRoomDetail>({
      endpoint: `/rooms/${roomId}/contract/${contractId}`,
      auth: Auth.REQUIRED,
    })

    return {
      response: data,
      error: null,
    }
  } catch (error) {
    if (error instanceof HttpError) {
      return {
        response: null,
        error: error.code,
      }
    }

    return {
      response: null,
      error,
    }
  }
}
